import { Component, OnInit, ChangeDetectorRef, NgZone, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AngularFireAuth } from '@angular/fire/auth';
import { UplatnicaDialogComponent } from 'src/app/uplatnica-dialog/uplatnica-dialog.component';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  @Input() order_id;
  orders: any[];
  loggedInUser: any;
  constructor(
    private firestore: AngularFirestore,
    private auth: AngularFireAuth,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private fsFuncs: AngularFireFunctions,
    public zone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    auth.onAuthStateChanged(async (userInfo) => {
      this.loggedInUser = userInfo;
      this.getUserOrders();
    })
  }

  ngOnInit(): void {
  }
  async getUserOrders() {
    this.firestore.collection(`users/${this.loggedInUser.uid}/orders`).get()
      .subscribe((data) => {
        this.orders = data.docs.map((ord) => {
          var o = ord.data();
          o.id = ord.id;
          o.ngClass={
            pulse: (this.order_id == o.id)
          }
          o.date = o.datetime.toDate();
          return o;
        }).sort((a, b) => { return b.date.getTime() - a.date.getTime() })
        if (this.order_id)
          setTimeout(() => {
            var element = document.getElementById(this.order_id);
            element.scrollIntoView(false);
          }, 300)
      })
  }
  async deleteOrder(order) {
    this.firestore.doc(`users/${(await this.auth.currentUser).uid}/orders/${order.id}`)
      .update({
        deleted: true
      })
      .then((data) => {
        order.deleted = true;
        this.openSnackBar("Porudžbina obrisana", "OK")
      })
      .catch(err => {
        this.openSnackBar("Neuspešno brisanje", "OK")
        console.log(err)
      })
  }
  async openUplatnicaDialog(order, upgrade?) {
    var userSnap = await this.firestore.doc(`users/${(await this.auth.currentUser).uid}/`).get().toPromise()
    var user = userSnap.data();
    user.id = (await this.auth.currentUser).uid;
    var width = '80%';
    const dialogRef = this.dialog.open(UplatnicaDialogComponent, {
      width: width,
      height: '90%',
      data: {
        order: order,
        user: user,
        upgrade:upgrade
      },
      panelClass: 'submitDialogStyle',
    });
    dialogRef.afterClosed().subscribe(result => {
    });
    return dialogRef;
  }
  openSnackBar(message: string, action: string, top?: boolean) {
    this._snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: (top) ? 'top' : 'bottom'
    });
  }
}
